import React from 'react';

import { Spinner } from './styles';

export default function index({ options }) {
  return (
    <Spinner options={options} />
  );
}
